import { Modal, Button } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import "../modal.css";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import { useFormik } from "formik";
import * as Yup from "yup";
import Loader from "../Loader";
const phoneRegExp = /^(^\+251|^251|^0)?9\d{8}$/;
const basicSchema = Yup.object().shape({
  companyName: Yup.string().required("Company name is required"),
  contactPerson: Yup.string().required("Contact person is required"),
  address: Yup.string().required("Address is required"),
  balance: Yup.number().required("Balance is required"),
  creditLimit: Yup.number().required("Credit limit is required"),
  phoneNumber: Yup.string()
    .matches(phoneRegExp, "Phone number is not valid")
    .required(),
  startDate: Yup.date()
    .nullable()
    .required("Start date is required")
    .min(new Date(), "Start Date must be later than today"),

  endDate: Yup.date()
    .nullable()
    .required("End date is required")
    .min(new Date(), "End Date must be later than today"),
  status: Yup.string().required("Status is required"),
});

const AddCompany = ({ showModal, hideModal, getCompanies }) => {
  const history = useNavigate();
  let [loading, setLoading] = useState(false);
  let [errorMsg, setErrorMsg] = useState(true);
  const onSubmit = async (values, actions) => {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    addCompany(values);
    setLoading(true);
  };

  const {
    values,
    errors,
    touched,
    isSubmitting,
    setFieldValue,
    handleBlur,
    handleChange,
    handleSubmit,
    submitForm,
  } = useFormik({
    initialValues: {
      companyName: "",
      contactPerson: "",
      address: "",
      balance: "",
      creditLimit: "",
      phoneNumber: "",
      startDate: "",
      endDate: "",
      status: "",
    },
    validationSchema: basicSchema,
    onSubmit,
  });

  const customDatePickerStyles = {
    borderRadius: "5px",
    border: "1px solid #ccc",
    padding: "7px",
    fontWeight: 500,
    width: "135%",
    color: "#494848",
  };

  const DatePickerField = ({ name, value, onChange }) => {
    return (
      <DatePicker
        selected={(value && new Date(value)) || null}
        onChange={(val) => {
          onChange(name, val);
        }}
        customInput={<input style={customDatePickerStyles} />}
      />
    );
  };

  const notifySuccess = () =>
    toast.success("Company Added.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const addCompany = async (e) => {
    console.log("======there u are=======");
    try {
      const bodyFormData = new FormData();
      for (let value in values) {
        bodyFormData.append(value, values[value]);
      }
      const response = await axios
        .post("/company", bodyFormData)
        .then((res) => {
          //   history("/drivers");
          hideModal();
          getCompanies();
          notifySuccess();
        })
        .catch((err) => {
          setLoading(false);
          setErrorMsg(err.response.data.msg);
          notifyError();
        });
    } catch (error) {
      notifyError();
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete="off"
      encType="multipart/form-data"
    >

      <Modal
        style={{ marginTop: "60px" }}
        show={showModal}
        onHide={hideModal}
        backdrop={false}
        contentClassName="custom-modal-styles"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Company</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading && (
            <div
              style={{
                position: "absolute",
                zIndex: "1000",
                top: 50 + "%",
                left: 50 + "%",
              }}
            >
              <Loader />
            </div>
          )}

          <div class="row">
            <div class="col-md-6">
              <div class="card card-primary">
                <div class="card-body">
                  <div class="form-group">
                    <label for="companyName">Company Name</label>
                    <input
                      type="text"
                      name="companyName"
                      value={values.companyName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.companyName && touched.companyName
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.companyName && touched.companyName && (
                      <p className="error">{errors.companyName}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="contactPerson">Contact Person</label>
                    <input
                      type="text"
                      name="contactPerson"
                      value={values.contactPerson}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.contactPerson && touched.contactPerson
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.contactPerson && touched.contactPerson && (
                      <p className="error">{errors.contactPerson}</p>
                    )}
                  </div>
                  <div class="form-group">
                    <label for="inputName">Address</label>
                    <input
                      type="text"
                      id="inputName"
                      name="address"
                      value={values.address}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.address && touched.address
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.address && touched.address && (
                      <p className="error">{errors.address}</p>
                    )}
                  </div>
                  <div class="form-group">
                    <label for="balance">Balance</label>
                    <input
                      type="number"
                      id="balance"
                      name="balance"
                      value={values.balance}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.balance && touched.balance
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.balance && touched.balance && (
                      <p className="error">{errors.balance}</p>
                    )}
                  </div>
                  <div class="form-group">
                    <label for="creditLimit">Credit Limit</label>
                    <input
                      type="number"
                      id="creditLimit"
                      name="creditLimit"
                      value={values.creditLimit}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.creditLimit && touched.creditLimit
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.creditLimit && touched.creditLimit && (
                      <p className="error">{errors.creditLimit}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card card-success">
                <div className="card-body">
                  <div class="form-group">
                    <label for="inputName">Phone Number</label>
                    <input
                      type="text"
                      id="inputName"
                      name="phoneNumber"
                      value={values.phoneNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.phoneNumber && touched.phoneNumber
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.phoneNumber && touched.phoneNumber && (
                      <p className="error">{errors.phoneNumber}</p>
                    )}
                  </div>
                  <div class="form-group">
                    <label for="startDate">Start Date</label>
                    <br />
                    <DatePickerField
                      name="startDate"
                      id="startDate"
                      class="form-control"
                      value={values.startDate}
                      onChange={setFieldValue}
                      className={
                        errors.startDate && touched.startDate
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />

                    {errors.startDate && touched.startDate && (
                      <p className="error">{errors.startDate}</p>
                    )}
                  </div>
                  <div class="form-group">
                    <label for="endDate">End Date</label>
                    <br />
                    <DatePickerField
                      name="endDate"
                      id="endDate"
                      class="form-control"
                      value={values.endDate}
                      onChange={setFieldValue}
                      className={
                        errors.endDate && touched.endDate
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />

                    {errors.endDate && touched.endDate && (
                      <p className="error">{errors.endDate}</p>
                    )}
                  </div>
                  <div className="form-group">
                    <label for="inputStatus">Status</label>
                    <select
                      id="inputStatus"
                      class="form-control custom-select"
                      name="status"
                      value={values.status}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.status && touched.status
                          ? "form-control input-error"
                          : "form-control "
                      }
                    >
                      <option selected>Select Status</option>
                      <option value={"Active"}>Active</option>
                      <option value={"Inactive"}>Inactive</option>
                    </select>
                    {errors.status && touched.status && (
                      <p className="error">{errors.status}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {errorMsg && (
            <div>
              <h5 className="error">{errorMsg}</h5>
            </div>
          )}
          <Button variant="default" onClick={hideModal}>
            Cancel
          </Button>

          <button
            disabled={isSubmitting}
            onClick={submitForm}
            className="btn btn-success"
            type="submit"
          >
            Submit
          </button>
        </Modal.Footer>
      </Modal>
    </form>
  );
};

export default AddCompany;
